export const FLAG_GETTING_MAINTENANCE_BUS_FLEETS = 'FLAG_GETTING_MAINTENANCE_BUS_FLEETS';
export const GET_MAINTENANCE_BUS_FLEETS = 'GET_MAINTENANCE_BUS_FLEETS';
export const CLEAR_MAINTENANCE_BUS_FLEETS = 'CLEAR_MAINTENANCE_BUS_FLEETS';

export const GET_MAINTENANCE_BUS_FLEET = 'GET_MAINTENANCE_BUS_FLEET';
export const CLEAR_MAINTENANCE_BUS_FLEET = 'CLEAR_MAINTENANCE_BUS_FLEET';
export const FLAG_GETTING_MAINTENANCE_BUS_FLEET = 'FLAG_GETTING_MAINTENANCE_BUS_FLEET';

export const GET_HISTORY_OF_BUS_MAINTENANCE_STAY = 'GET_HISTORY_OF_BUS_MAINTENANCE_STAY';
export const CLEAR_HISTORY_OF_BUS_MAINTENANCE_STAY = 'CLEAR_HISTORY_OF_BUS_MAINTENANCE_STAY';
export const FLAG_GETTING_HISTORY_OF_BUS_MAINTENANCE_STAY = 'FLAG_GETTING_HISTORY_OF_BUS_MAINTENANCE_STAY';
